import { CommonModule } from '@angular/common';

import { AfterViewInit,Component,Inject,ViewChild } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { MatLegacyDialogModule,MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyTable,MatLegacyTableModule } from '@angular/material/legacy-table';
import { ArlDataFromFile } from '@dave/types';

import { SelectionModel } from '@angular/cdk/collections';
import { FormControl,ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppButtonModule } from '../../../dave-utils-module/app-button-module/app-button.module';
import { AppFilterModule } from '../../../dave-utils-module/app-filter-module/app-filter.module';
import { SelectSearchModule } from '../../../dave-utils-module/select-search/select-search.module';
import { appMatDialogDefaultConfig } from '../../../helper/helper';
import { SelectGaebArlDataTableDatasource,SelectGaebArlDataTableItem } from './select-gaeb-arl-data-table-datasource';
import { Store } from '@ngrx/store';
import { State } from '../../../dave-data-module/State';
import { getNotDeletedSuppliers } from '../../../dave-data-module/State/selectors/customers.selectors';
import { map } from 'rxjs/operators';
import {
    SelectSearchOption
} from '../../../dave-utils-module/select-search/components/select-search/select-search.component';
import { Observable } from 'rxjs';
import { CustomerEntity } from '../../../dave-data-module/entities/customer.entity';
import { CustomLabelService } from '../../../services/custom-label/custom-label.service';
import {
    MatLegacyPaginator,
    MatLegacyPaginatorIntl as MatPaginatorIntl,
    MatLegacyPaginatorModule,
} from '@angular/material/legacy-paginator';
import { MatPaginatorWrapperComponent } from '../../../mat-paginator-wrapper/mat-paginator-wrapper.component';
import { GermanPaginatorIntl } from '../../../services/german-paginator-intl.service';
export interface SelectGaebArlDataComponentDialogData {
    bookingPositions: ArlDataFromFile[];
}
export type SelectGaebArlDataComponentDialogReturnData = undefined | {
    arls: SelectGaebArlDataTableItem[],
    supplierId: number | null,
};

@Component({
    selector: 'app-select-gaeb-arl-data',
    templateUrl: './select-gaeb-arl-data.component.html',
    styleUrls: ['./select-gaeb-arl-data.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FontAwesomeModule,
        MatLegacyDialogModule,
        MatLegacyTableModule,
        /*MatLegacyCheckboxModule,*/ MatCheckboxModule,
        AppButtonModule,
        ReactiveFormsModule,
        MatLegacyInputModule,
        MatLegacyButtonModule,
        AppFilterModule,
        MatLegacyTooltipModule,
        MatBadgeModule,
        SelectSearchModule, MatLegacyPaginatorModule, MatPaginatorWrapperComponent,
    ],
    providers: [{ provide: MatPaginatorIntl, useClass: GermanPaginatorIntl }],

})
export class SelectGaebArlDataComponent implements AfterViewInit {
    public static DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        minWidth: '100%',
        // height: '90%',
    };
    @ViewChild(MatLegacyPaginator) paginator!: MatLegacyPaginator;
    @ViewChild(MatLegacyTable) table!: MatLegacyTable<SelectGaebArlDataTableItem>;
    protected searchForm = new FormControl<string>('');
    protected supplierForm = new FormControl<CustomerEntity>(null);
    protected suppliers$ = this.store.select(getNotDeletedSuppliers);
    protected supplierLabel$ = this.cls.getSingle$('Supplier');
    protected bookingPositions: ArlDataFromFile[];
    protected displayedColumns: Array<keyof SelectGaebArlDataTableItem | 'select'> = ['select', 'itemNumber', 'articleNumber', 'name', 'price'];
    protected currencyColumns: Array<{ columnName: keyof SelectGaebArlDataTableItem; header: string }> = [
        {
            columnName: 'price',
            header: 'Preis',
        },
    ];
    protected textColumns: Array<{ columnName: keyof SelectGaebArlDataTableItem; header: string }> = [
        {
            columnName: 'itemNumber',
            header: 'Pos.',
        },
        {
            columnName: 'articleNumber',
            header: 'Art-Nr.',
        },
        {
            columnName: 'name',
            header: 'Bezeichnung',
        },
    ];

    datasource: SelectGaebArlDataTableDatasource;
    selection = new SelectionModel<SelectGaebArlDataTableItem>(true, []);

    constructor(@Inject(MAT_LEGACY_DIALOG_DATA) dialogData: SelectGaebArlDataComponentDialogData, private store: Store<State>, private cls: CustomLabelService) {
        if (!dialogData.bookingPositions) {
            throw new Error('No booking positions provided');
        }
        this.datasource = new SelectGaebArlDataTableDatasource(dialogData.bookingPositions);
        this.datasource.searchQuery$ = this.searchForm.valueChanges;

        this.bookingPositions = dialogData.bookingPositions;
    }
    ngAfterViewInit(): void {
        this.datasource.paginator = this.paginator;
        this.table.dataSource = this.datasource;
    }
    checkBoxChange(row: SelectGaebArlDataTableItem) {
        this.selection.toggle(row);
    }
    isAllSelected() {
        return this.selection.selected.length === this.datasource.data.filter((d) => !!d.matchedArlId).length;
    }

    toggleAllRows() {
        this.isAllSelected() ? this.deSelectAll() : this.selectAll();
    }
    deSelectAll() {
        this.selection.clear();
    }
    selectAll() {
        this.datasource.data
            .filter((d) => !!d.matchedArlId)
            .forEach((row) => {
                this.selection.select(row);
            });
    }
}
